






















import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import { RED } from "@/resources/constants/busyReasons";
import { UsersService } from "@/services/users/users.service";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";

@Component({
  name: "user-icon-menu-component",
})
export default class UserIconMenuComponent extends mixins(FloatMenuAnimation) {
  image = null;
  city = false;
  mounted(): void {
    this.city = localStorage.getItem("city") == "ON" ? true : false;
  }
  get user(): any {
    let user = null;
    if (this.city) {
      const data = {
        user: this.$store.getters["UserStore/getUser"],
      };
      user = data.user || {
        user: { availableStatus: RED.color, profileImage: { id: 0 } },
      };
    } else if (this.$store.getters["UserStore/getSpaceUser"])
      user = this.$store.getters["UserStore/getSpaceUser"].superSpaceUser
        .user || {
        user: { availableStatus: RED.color, profileImage: { id: 0 } },
      };
    return user;
  }
  clickInMenu(): void {
    this.$store.dispatch("FloatMenuStore/setOpenProfileAction", true);
  }
  focusUser(): void {
    this.$store.dispatch("GraphicClientStore/focusUserAction", this.user.id);
  }
}
